var Ajax = require("./Ajax");
var radio = require("react-pubsub-via-radio.js/radio");
var esUtils = require("../utils/esUtils");

var write = function(data){
	Ajax.get("/js-bug-hunter?" + esUtils.phpCompatibleParams(data));
	console.log("WRITE TO SERVER LOG", data);
};

if((typeof window !== "undefined") && (process.env.NODE_ENV === "production")){
	var session_data = typeof AUTHED_USER_SESSION !== "undefined" ? AUTHED_USER_SESSION : {};
	var username = (session_data.balboa && session_data.balboa.username) || "unknown";
	window.onerror = function(message, file_url, line, col, errorObj){
		try{
			write({
				message: message,
				file_url: file_url,
				username: username,
				js_file_url: errorObj && errorObj.fileName,
				stack: errorObj && errorObj.stack,
				line: line,
				col: col,
				url: window.location.href
			});
		}catch(e){
		}
		return true;
	};
}

module.exports.init = function(){
	radio("BugHunter_logit").subscribe(write);
};



//////////////////
// WEBPACK FOOTER
// ./~/ES/services/BugHunter.js
// module id = 174
// module chunks = 0 1 2 3 4